<template>
  <div class="home-panel">
    <main-event/>
      <news-and-update-page v-if="!isLoggedIn"/>
      <guidelines-page v-if="!isLoggedIn"/>
      <event-page v-if="!isLoggedIn"/>
      <item-shop-page  v-if="user && isLoggedIn"/>
  </div>
</template>
<script>
import MainEvent from '@/components/home/MainEvent.vue';
import NewsAndUpdatePage from '@/components/news-and-update/NewsAndUpdatePage.vue';
import GuidelinesPage from '@/components/guidelines/GuidelinesPage.vue';
import EventPage from '@/components/event/EventPage.vue'
import ItemShopPage from '@/components/user-panel/contents/item-shop/ItemShopPage.vue';

import { mapGetters } from 'vuex';
export default {
  name: 'HomePanel',
  computed: {
    ...mapGetters({
      user: 'user/getUser',
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  components: {
    MainEvent,
    NewsAndUpdatePage,
    GuidelinesPage,
    EventPage,
    ItemShopPage
  }
}
</script>
<style lang="scss">
  .home-panel {
    display: grid;
    grid-template-rows: 1fr;
    gap: 16px;
  }
</style>